import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { ApiError } from "../api/client";
import { exitActingClinic } from "../api/endpoints";
import { useActingClinic } from "../hooks/useActingClinic";

/**
 * Stays on screen for as long as a superadmin is standing in a clinic.
 *
 * Deliberately loud rather than a small badge: everything below this banner —
 * the console, the rota, the billing page — looks exactly like that clinic's
 * own administration surface, and the one thing telling a superadmin (or
 * anyone glancing at their screen) that they are visiting rather than home is
 * this line.
 */
export default function ActingBanner() {
  const acting = useActingClinic();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  if (!acting) return null;

  return (
    <div className="banner banner--acting" role="status">
      <span>
        Managing <strong>{acting.name}</strong> as Superadmin
      </span>
      {error && <span className="banner__error">{error}</span>}
      <button
        disabled={busy}
        onClick={() => {
          setBusy(true);
          setError("");
          void exitActingClinic()
            .then(() => { void navigate("/onboard"); })
            .catch((cause: unknown) => {
              // Left up on purpose — the exit call failing means nothing was
              // undone, so the banner staying put is the honest state.
              setError(cause instanceof ApiError ? cause.message : "Could not exit.");
            })
            .finally(() => { setBusy(false); });
        }}
      >
        Exit
      </button>
    </div>
  );
}
